import { type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react'
import { cn } from '#app/utils/misc.tsx'

/**
 * Text field: 50px, radius 14, 2px border that turns accent on focus, 16px
 * type (never smaller — iOS zooms into anything under 16px). Label it with
 * an OyLabel / OyTrayField.
 */
export function OyField({
	className,
	type = 'text',
	...props
}: InputHTMLAttributes<HTMLInputElement>) {
	return <input type={type} className={cn('oy-field', className)} {...props} />
}

export function OyTextarea({
	className,
	...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
	return <textarea className={cn('oy-textarea', className)} {...props} />
}

/** 15/700 muted, sentence case (fase 5b); `level="page"` is the 16px page variant. */
export function OySectionLabel({
	level = 'card',
	as: Tag = 'div',
	className,
	children,
	...props
}: {
	level?: 'card' | 'page'
	as?: 'div' | 'label' | 'h2' | 'h3' | 'span'
	className?: string
	id?: string
	htmlFor?: string
	children: React.ReactNode
}) {
	return (
		<Tag
			className={cn('oy-label', level === 'page' && 'page', className)}
			{...props}
		>
			{children}
		</Tag>
	)
}
